<template>
  <div class="fondo_transparente">
    <div class="ventana_modal" id="dragg-cont" ref="draggCont">
      <XCerrarModal sizeX="P" @click="cerrarModal" id="XCerrar"/>
      <div class="header" id="dragg-header" @mousedown="dragMouseDown">
        <p>Boletín</p>
      </div>
      <div class="body">
        <select name="boletines" id="" class="campo" v-model="selectedBoletin">
          <option v-for="(boletin, index) in boletines"
            :key="index"
            :value="boletin.Bol">
            {{boletin.Bol}}
          </option>
        </select>
        <div class="flecha" @click="enviar">&rtrif;</div>
      </div>
    </div>
  </div>
</template>

<script>
import XCerrarModal from './XCerrarModal.vue'
import boletines from '../assets/JSON/BSVE.json'
export default {
  components: { XCerrarModal },
  name: 'ModalAutores',
  created () {
    this.boletines = boletines.sort(function (a, b) {
      if (a.anyo > b.anyo) { return 1 }
      if (a.anyo < b.anyo) { return -1 }
      return 0
    })
  },
  data () {
    return {
      boletines: [],
      selectedBoletin: '',
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      }
    }
  },
  methods: {
    cerrarModal: function () {
      this.visible = false
      this.$emit('cerrar')
    },
    enviar () {
      if (this.selectedBoletin) {
        this.$emit('AddBoletin', this.selectedBoletin)
        this.cerrarModal()
      }
    },
    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      // set the element's new position:
      this.$refs.draggCont.style.top = (this.$refs.draggCont.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggCont.style.left = (this.$refs.draggCont.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },
  computed: {
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.ventana_modal{
  /* background-color: rgb(211, 210, 210); */
  background-color: var(--azul2);
  width: 300px;
  height: 100px;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  border-radius: 5px;
  display: grid;
  grid-template-rows: 60% 40%;
  font-family: OpenL;
  /* border:  1px solid rgb(179, 179, 179) */
  z-index: 100;
  box-shadow: rgb(43, 43, 43) 4px 4px 20px;
}
.header{
  background-color: var(--azul2);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  display: flex;
}
.header p{
  text-align: left;
  margin-left: 20px;
  align-self: center;
  color: var(--na);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 22px;
  font-weight: lighter;
}
.body{
  /* margin: 18px; */
  display:flex;
  color:rgb(20, 76, 109);
  justify-content: center;
}
.campo {
  width: 75%;
  height: 26px;
  font-size: 15px;
  padding-left: 8px;
}
.flecha {
  font-size: 40px;
  /* position: absolute; */
  /* right: 14px; */
  color:white;
  /* top: 9px; */
  width: 25px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 15px;
  transition: all 0.5s ease-out;
  /* border: solid 1px rgba(1, 117, 163, 0); */
  /* border:1px solid darkorange; */
}
.flecha:hover {
  transform: translateX(4px);
}
#dragg-cont {
  position: absolute;
  z-index: 9;
}
#dragg-header {
  cursor: move;
  z-index: 10;
}
#XCerrar{
  z-index: 11;
}
</style>
